/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Allowlist_PlaceholderInputs */



/**
* | output |
* | --- |
* | "@acme.de" |
*
* @param {Artifact_Visitor_Allowlist_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_allowlist_placeholder = /** @type {((inputs?: Artifact_Visitor_Allowlist_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Allowlist_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("@acme.de")
	return /** @type {LocalizedString} */ ("@acme.de")
});